export const warningMessageType = {
  text: "text",
  hidden: "hidden"
};
